import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import InformationHubPost from './InformationHubPost';

interface InformationHubListProps {
  posts: any[];
  isLoading?: boolean;
  error?: string | null;
}

// export default function InformationHubList({ posts, isLoading, error }: InformationHubListProps) {
//   const [selectedPost, setSelectedPost] = useState<any | null>(null);

//   if (isLoading) {
//     return (
//       <div className="bg-surface-light rounded-xl p-6">
//         <div className="animate-pulse space-y-6">
//           {[...Array(4)].map((_, i) => (
//             <div key={i}>
//               <div className="flex items-start gap-4">
//                 <div className="w-24 h-24 bg-surface rounded-lg" />
//                 <div className="flex-1">
//                   <div className="h-0.5 w-full bg-surface mb-2" />
//                   <div className="h-4 w-3/4 bg-surface rounded" />
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="bg-surface-light rounded-xl p-6">
//         <div className="text-center text-secondary-dark p-4">
//           {error}
//         </div>
//       </div>
//     );
//   }

//   if (!posts.length) {
//     return (
//       <div className="bg-surface-light rounded-xl p-6">
//         <div className="text-center text-neutral p-4">
//           No posts available
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-surface-light rounded-xl min-h-[calc(100vh-8rem)] overflow-hidden">
//       <div className="relative h-full">
//         <div
//           className={`transition-transform duration-300 ease-in-out ${
//             selectedPost ? '-translate-x-full' : 'translate-x-0'
//           }`}
//         >
//           <div className="p-6">
//             <div className="flex flex-col space-y-6">
//               {posts.map((post) => (
//                 <article 
//                   key={post.id}
//                   onClick={() => setSelectedPost(post)}
//                   className="group cursor-pointer"
//                 >
//                   <div className="flex items-start gap-4">
//                     <div className="w-24 h-24 overflow-hidden rounded-lg flex-shrink-0">
//                       <img
//                         src={post.cover_image || 'https://images.unsplash.com/photo-1516280440614-37939bbacd81'}
//                         alt={post.title}
//                         className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
//                       />
//                     </div>
//                     <div className="flex-1">
//                       <div className="h-1 w-full bg-primary mb-2" />
//                       <h2 className="text-xl font-bold text-primary group-hover:text-accent transition-colors">
//                         {post.title}
//                       </h2>
//                     </div>
//                   </div>
//                 </article>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div
//           className={`absolute top-0 left-full w-full h-screen transition-transform duration-300 ease-in-out overflow-y-auto ${
//             selectedPost ? '-translate-x-full' : 'translate-x-0'
//           }`}
//         >
//           {selectedPost && (
//             <div className="p-2">
//               <button
//                 onClick={() => setSelectedPost(null)}
//                 className="flex items-center text-neutral hover:text-primary transition-colors mb-2"
//               >
//                 <ArrowLeft className="w-5 h-5 mr-2" />
//                 Back to posts
//               </button>
//               <InformationHubPost post={selectedPost} />
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
export default function InformationHubList({ posts, isLoading, error }: InformationHubListProps) {
  const [selectedPost, setSelectedPost] = useState<any | null>(null);

  if (isLoading) {
    return (
      <div className="bg-surface-light rounded-xl p-6">
        <div className="animate-pulse space-y-6">
          {[...Array(4)].map((_, i) => (
            <div key={i}>
              <div className="flex items-start gap-4">
                <div className="w-24 h-24 bg-surface rounded-lg" />
                <div className="flex-1">
                  <div className="h-0.5 w-full bg-surface mb-2" />
                  <div className="h-4 w-3/4 bg-surface rounded" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-surface-light rounded-xl p-6">
        <div className="text-center text-secondary-dark p-4">
          {error}
        </div>
      </div>
    );
  }

  if (!posts.length) {
    return (
      <div className="bg-surface-light rounded-xl p-6">
        <div className="text-center text-neutral p-4">
          No posts available
        </div>
      </div>
    );
  }

  return (
    <div className="bg-surface-light rounded-xl min-h-[calc(100vh-8rem)] overflow-hidden relative"> {/* Added overflow-hidden and relative */}
      {/* Posts list view */}
      <div
        className={`transition-transform duration-300 ease-in-out ${
          selectedPost ? '-translate-x-full' : 'translate-x-0'
        }`}
      >
        <div className="p-6">
          <div className="flex flex-col space-y-6">
            {posts.map((post) => (
              <article 
                key={post.id}
                onClick={() => setSelectedPost(post)}
                className="group cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="w-24 h-24 overflow-hidden rounded-lg flex-shrink-0">
                    <img
                      src={post.cover_image || 'https://images.unsplash.com/photo-1516280440614-37939bbacd81'}
                      alt={post.title}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex-1">
                    <div className="h-1 w-full bg-primary mb-2" />
                    <h2 className="text-xl font-bold text-primary group-hover:text-accent transition-colors">
                      {post.title}
                    </h2>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>

      {/* Post detail view */}
      <div
        className={`absolute inset-0 transition-transform duration-300 ease-in-out overflow-y-auto ${
          selectedPost ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {selectedPost && (
          <div className="p-2 bg-surface-light h-full"> {/* Added h-full */}
            <button
              onClick={() => setSelectedPost(null)}
              className="flex items-center text-neutral hover:text-primary transition-colors mb-2"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Back to posts
            </button>
            <InformationHubPost post={selectedPost} />
          </div>
        )}
      </div>
    </div>
  );
}